import { EmptyVoidCallback } from '@/travelsuit/callback'
import { User } from '@/types/user'

const ENVIRONMENT = 'prod'
const DEPLOYMENT_ID = '8552100d-fb19-4173-8f4a-b9e12fd7d4a7'

export function openExternalChatPopup(cb?: EmptyVoidCallback) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const w = window as any

	if (w.Genesys) {
		w.Genesys('command', 'Messenger.open')
	} else {
		console.warn('Genesys cloud not found')
	}

	cb?.()
}

export const initGenesysCloudChat = (user: User) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const w = window as any
	const initGenesys = () => {
		w.Genesys('command', 'Database.set', {
			messaging: {
				customAttributes: {
					name: `${user.first_name} ${user.last_name}`,
					email: user.email,
					country: user.invoice_profile?.country?.name || '',
					companyName: user.invoice_profile?.display_name || '',
					phoneNumber: user.traveler_profile?.phone_number || '',
				},
			},
		})
	}

	if (!document.getElementById('Genesys-Messaging-SDK')) {
		const script = document.createElement('script')
		script.id = 'Genesys-Messaging-SDK'
		script.async = true
		script.src = 'https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js'
		document.head.appendChild(script)

		w._genesysJs = 'Genesys'
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		w.Genesys = (...args: any[]) => {
			;(w.Genesys.q = w.Genesys.q || []).push(args)
		}
		w.Genesys.c = {
			environment: ENVIRONMENT,
			deploymentId: DEPLOYMENT_ID,
		}
		w.Genesys.t = Date.now()

		script.onload = initGenesys
	} else {
		initGenesys()
	}
}

export const hideGenesysChatbot = () => {
	const genesysIframe = document.getElementById('genesys-mxg-frame')
	if (genesysIframe) {
		genesysIframe.style.display = 'none'
	}
}

export const showGenesysChatbot = () => {
	const genesysIframe = document.getElementById('genesys-mxg-frame')
	if (genesysIframe) {
		genesysIframe.style.display = 'block'
	}
}
